export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}
